export default "__VITE_ASSET__332c8262__"